const e = {
  name: "Code2",
  dimensions: { width: 24, height: 24 },
  content: `
    <g>
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.29289 8.29289C7.68342 7.90237 8.31658 7.90237 8.70711 8.29289L11.7071 11.2929C12.0976 11.6834 12.0976 12.3166 11.7071 12.7071L8.70711 15.7071C8.31658 16.0976 7.68342 16.0976 7.29289 15.7071C6.90237 15.3166 6.90237 14.6834 7.29289 14.2929L9.58579 12L7.29289 9.70711C6.90237 9.31658 6.90237 8.68342 7.29289 8.29289Z" fill="currentColor"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M14 14C13.4477 14 13 14.4477 13 15C13 15.5523 13.4477 16 14 16H16C16.5523 16 17 15.5523 17 15C17 14.4477 16.5523 14 16 14H14Z" fill="currentColor"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M2 5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5ZM5 4C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V5C20 4.44772 19.5523 4 19 4H5Z" fill="currentColor"/>
    </g>
    `
};
export {
  e as Code2
};
